import { useCallback } from 'react';
import { useSecurity } from '../providers/SecurityProvider';

// Mantenemos la variable de control de abortos fuera para que persista entre renders
const pendingRequests = {};

const MESSAGE_ERROR = { error: true, message: "Error inesperado", codeError: 500 };

export function useConnection() {
    // 1. Obtenemos la instancia de API del contexto (ya tiene el token configurado)
    const { api } = useSecurity();

    // 2. Creamos la función wrapper compatible con la firma antigua
    const connection = useCallback(async ({
        method = "GET",
        url = "", // OJO: api.request concatenará esto a su baseURL configurada
        extraHeaders = {},
        body,
        formDataMode = false,
        signal = null,
        abortRepect = false,
        responseType = "json",
        // authUrl = false // Nota: El objeto 'api' ya tiene una URL base definida. 
        // Si necesitas cambiar a Auth, quizás debas usar el objeto 'auth' del contexto.
    }) => {

        // Lógica de AbortController (Legacy support)
        if (abortRepect && pendingRequests[url]) {
            pendingRequests[url].abort();
        }

        // Si no viene señal externa, creamos una para gestionarla internamente
        const controller = new AbortController();
        const internalSignal = signal || controller.signal;

        if (abortRepect) pendingRequests[url] = controller;

        try {
            // 3. LLAMADA AL NUEVO SISTEMA
            // Mapeamos los parámetros antiguos a los del nuevo ApiClient

            // Nota: api.request espera (method, path, body, extraOptions)
            // Usamos 'responseType' que agregamos al HttpClient 
            const responseData = await api.request({
                method,
                resource: url,
                body,
                opts: {
                    headers: extraHeaders,
                    signal: internalSignal,
                    responseType: responseType,
                    // Si el body es FormData, el HttpClient que hicimos ya sabe no stringificarlo
                }
            });

            // 4. ADAPTADOR DE RESPUESTA
            // EL código antiguo espera { data, status, ok } en ciertos casos o la data directa en json.
            // El HttpClient nuevo devuelve la data parseada directamente si es JSON.

            // Si es Blob, el nuevo HttpClient devuelve el blob directo.
            // Para mantener compatibilidad estricta con tu código antiguo:
            if (responseType === 'blob') {
                return {
                    data: responseData,
                    status: 200, // Asumimos éxito si no lanzó error
                    ok: true
                };
            }

            return responseData;

        } catch (error) {
            // Manejo de errores para que coincida con lo que tu app espera (no lanzar excepción, sino retornar objeto)

            console.error(error?.name || "RequestError", error?.status || error?.codeError, error?.message);

            // Si fue abortado
            if (error.name === 'AbortError' || signal?.aborted) {
                return {
                    ...MESSAGE_ERROR,
                    message: "Petición cancelada",
                    codeError: 103,
                };
            }

            // Si es error HTTP (viene de nuestra clase HttpError)
            if (error.name === 'HttpError') {
                // Manejo específico de 401 si es necesario, aunque el AuthClient debería manejarlo
                /* if (error.status === 401) { ... } */

                return {
                    ...MESSAGE_ERROR,
                    message: error.body?.message || error.message || "Error en la petición",
                    status: error.status,
                    originalError: error,
                    headers: error.headers || error.response?.headers,
                    ...error.body
                };
            }

            return {
                ...MESSAGE_ERROR,
                message: error.message,
                status: 0,
                networkError: true,
                originalError: error,
            };

        } finally {
            if (abortRepect) delete pendingRequests[url];
        }

    }, [api]); // Se recrea solo si 'api' cambia

    return connection;
}











// import { useCallback } from 'react';
// import { useSecurity } from '../providers/SecurityProvider';

// // Mantenemos la variable de control de abortos fuera para que persista entre renders
// const pendingRequests = {};

// const MESSAGE_ERROR = { error: true, message: "Error inesperado", codeError: 500 };

// export function useConnection() {
//     // 1. Obtenemos la instancia de API del contexto (ya tiene el token configurado)
//     const { api } = useSecurity();

//     // 2. Creamos la función wrapper compatible con la firma antigua
//     const connection = useCallback(async ({
//         method = "GET",
//         url = "", // OJO: api.request concatenará esto a su baseURL configurada
//         extraHeaders = {},
//         body,
//         formDataMode = false,
//         signal = null,
//         abortRepect = false,
//         responseType = "json",
//         // authUrl = false // Nota: El objeto 'api' ya tiene una URL base definida. 
//         // Si necesitas cambiar a Auth, quizás debas usar el objeto 'auth' del contexto.
//     }) => {

//         // Lógica de AbortController (Legacy support)
//         if (abortRepect && pendingRequests[url]) {
//             pendingRequests[url].abort();
//         }

//         // Si no viene señal externa, creamos una para gestionarla internamente
//         const controller = new AbortController();
//         const internalSignal = signal || controller.signal;

//         if (abortRepect) pendingRequests[url] = controller;

//         try {
//             // 3. LLAMADA AL NUEVO SISTEMA
//             // Mapeamos los parámetros antiguos a los del nuevo ApiClient

//             // Nota: api.request espera (method, path, body, extraOptions)
//             // Usamos 'responseType' que agregamos al HttpClient 
//             const responseData = await api.request({
//                 method,
//                 resource: url,
//                 body,
//                 opts: {
//                     headers: extraHeaders,
//                     signal: internalSignal,
//                     responseType: responseType,
//                     // Si el body es FormData, el HttpClient que hicimos ya sabe no stringificarlo
//                 }
//             });

//             // 4. ADAPTADOR DE RESPUESTA
//             // EL código antiguo espera { data, status, ok } en ciertos casos o la data directa en json.
//             // El HttpClient nuevo devuelve la data parseada directamente si es JSON.

//             // Si es Blob, el nuevo HttpClient devuelve el blob directo.
//             // Para mantener compatibilidad estricta con tu código antiguo:
//             if (responseType === 'blob') {
//                 return {
//                     data: responseData,
//                     status: 200, // Asumimos éxito si no lanzó error
//                     ok: true
//                 };
//             }

//             return responseData;

//         } catch (error) {
//             // Manejo de errores para que coincida con lo que tu app espera (no lanzar excepción, sino retornar objeto)

//             console.error(error);

//             // Si fue abortado
//             if (error.name === 'AbortError' || signal?.aborted) {
//                 return {
//                     ...MESSAGE_ERROR,
//                     message: "Petición cancelada",
//                     codeError: 103,
//                 };
//             }

//             // Si es error HTTP (viene de nuestra clase HttpError)
//             if (error.name === 'HttpError') {
//                 // Manejo específico de 401 si es necesario, aunque el AuthClient debería manejarlo
//                 /* if (error.status === 401) { ... } */

//                 return {
//                     ...MESSAGE_ERROR,
//                     message: error.body?.message || error.message || "Error en la petición",
//                     status: error.status,
//                     originalError: error,
//                     ...error.body
//                 };
//             }

//             return { ...MESSAGE_ERROR, message: error.message };

//         } finally {
//             if (abortRepect) delete pendingRequests[url];
//         }

//     }, [api]); // Se recrea solo si 'api' cambia

//     return connection;
// }